import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';

export default function Register() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    gender: 'M',
    dob: '',
    address: '',
    caste: 'Brahmin',
    gotra: '',
    motherTongue: 'Nepali',
    occupation: '',
    education: 'Bachelors',
    hidePhone: true,
    blurPhoto: false,
    verifiedBadgeRequest: true
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (step < 3) {
      setStep(step + 1);
    } else {
      handleRegister();
    }
  };

  const handleRegister = async () => {
    setLoading(true);
    setError('');
    try {
      // Simulate backend registration call
      setTimeout(() => {
        setLoading(false);
        // Redirect to QR payment page for verification
        navigate('/consultation/payment');
      }, 1000);
    } catch (err) {
      setLoading(false);
      setError('Registration failed. Please check your details.');
    }
  };

  return (
    <div className="pi">
      <Navbar module="consult" />

      <div className="sh">
        <span className="ey ey-r">✦ Confidential Matrimonial Registry ✦</span>
        <h1>Create Your <em>Verified Profile</em></h1>
        <p>
          Hosted by <strong>Laxmikant Timilsina</strong> (Tansen-09, Palpa). Your data is 100% encrypted, private, and secure.
        </p>
      </div>

      <div className="sec" style={{ maxWidth: '720px' }}>
        {/* Step Progress Bar */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem',
          position: 'relative'
        }}>
          <div style={{
            position: 'absolute',
            top: '50%',
            left: 0,
            right: 0,
            height: '2px',
            background: 'var(--cream-d)',
            zIndex: 0
          }} />
          {[
            { num: 1, label: 'Personal Details' },
            { num: 2, label: 'Cultural & Horoscope' },
            { num: 3, label: 'Privacy & Security' }
          ].map((s) => (
            <div key={s.num} style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
              <div style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                background: step >= s.num ? 'var(--rose)' : 'var(--cream-d)',
                color: step >= s.num ? '#fff' : 'var(--muted)',
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 0.4rem',
                fontSize: '0.9rem',
                transition: 'all 0.3s ease'
              }}>
                {s.num}
              </div>
              <div style={{ fontSize: '0.72rem', fontWeight: 600, color: step >= s.num ? 'var(--rose)' : 'var(--muted)' }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>

        {error && <div className="al al-er">{error}</div>}

        <div className="card card-lg">
          <form onSubmit={handleNext}>
            {/* Step 1: Personal Details */}
            {step === 1 && (
              <div className="pi">
                <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.4rem', fontWeight: 700, marginBottom: '1.2rem' }}>
                  Step 1: Personal Profile
                </h3>

                <div className="g2">
                  <div className="fg">
                    <label>First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="e.g. Ramesh"
                      required
                    />
                  </div>
                  <div className="fg">
                    <label>Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="e.g. Sharma"
                      required
                    />
                  </div>
                </div>

                <div className="g2">
                  <div className="fg">
                    <label>Phone Number (Used for QR Activation)</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="e.g. 9841234567"
                      required
                    />
                  </div>
                  <div className="fg">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="e.g. ramesh@example.com"
                      required
                    />
                  </div>
                </div>

                <div className="g2">
                  <div className="fg">
                    <label>Gender</label>
                    <select name="gender" value={formData.gender} onChange={handleChange}>
                      <option value="M">Groom (Male)</option>
                      <option value="F">Bride (Female)</option>
                    </select>
                  </div>
                  <div className="fg">
                    <label>Date of Birth</label>
                    <input
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="fg">
                  <label>Permanent Address / District</label>
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="e.g. Tansen-09, Palpa or Butwal, Rupandehi"
                    required
                  />
                </div>
              </div>
            )}

            {/* Step 2: Cultural Background */}
            {step === 2 && (
              <div className="pi">
                <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.4rem', fontWeight: 700, marginBottom: '1.2rem' }}>
                  Step 2: Cultural Background & Horoscope
                </h3>

                <div className="g2">
                  <div className="fg">
                    <label>Caste / Community</label>
                    <input
                      type="text"
                      name="caste"
                      value={formData.caste}
                      onChange={handleChange}
                      placeholder="e.g. Brahmin, Chhetri, Newar, Gurung"
                      required
                    />
                  </div>
                  <div className="fg">
                    <label>Gotra</label>
                    <input
                      type="text"
                      name="gotra"
                      value={formData.gotra}
                      onChange={handleChange}
                      placeholder="e.g. Kasyap, Bharadwaj, Garga"
                    />
                  </div>
                </div>

                <div className="g2">
                  <div className="fg">
                    <label>Highest Qualification</label>
                    <select name="education" value={formData.education} onChange={handleChange}>
                      <option value="Bachelors">Bachelors Degree</option>
                      <option value="Masters">Masters Degree / PhD</option>
                      <option value="HighSchool">High School (10+2)</option>
                      <option value="Other">Professional Diploma</option>
                    </select>
                  </div>
                  <div className="fg">
                    <label>Occupation / Profession</label>
                    <input
                      type="text"
                      name="occupation"
                      value={formData.occupation}
                      onChange={handleChange}
                      placeholder="e.g. Civil Engineer, Teacher, Bank Officer"
                      required
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Step 3: Privacy & Data Security */}
            {step === 3 && (
              <div className="pi">
                <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.4rem', fontWeight: 700, marginBottom: '1.2rem' }}>
                  Step 3: Privacy & Security Controls
                </h3>

                <div className="privacy-shield">
                  <span>🔒</span>
                  <div>
                    <strong>Data Privacy Shield Active</strong>: Your phone number and photos are never shared publicly without your explicit consent.
                  </div>
                </div>

                <div style={{ background: 'var(--cream)', padding: '1.2rem', borderRadius: '12px', marginBottom: '1.5rem' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', cursor: 'pointer', marginBottom: '0.8rem', fontSize: '0.86rem', color: 'var(--deep)' }}>
                    <input
                      type="checkbox"
                      name="hidePhone"
                      checked={formData.hidePhone}
                      onChange={handleChange}
                      style={{ width: 'auto' }}
                    />
                    Hide My Phone Number (Only show after I accept connection request)
                  </label>

                  <label style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', cursor: 'pointer', marginBottom: '0.8rem', fontSize: '0.86rem', color: 'var(--deep)' }}>
                    <input
                      type="checkbox"
                      name="blurPhoto"
                      checked={formData.blurPhoto}
                      onChange={handleChange}
                      style={{ width: 'auto' }}
                    />
                    Blur My Profile Photo until requested
                  </label>

                  <label style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', cursor: 'pointer', fontSize: '0.86rem', color: 'var(--deep)' }}>
                    <input
                      type="checkbox"
                      name="verifiedBadgeRequest"
                      checked={formData.verifiedBadgeRequest}
                      onChange={handleChange}
                      style={{ width: 'auto' }}
                    />
                    Request Verified Member Badge (Verified by Laxmikant Timilsina)
                  </label>
                </div>
              </div>
            )}

            {/* Navigation Controls */}
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', marginTop: '1.5rem' }}>
              {step > 1 && (
                <button
                  type="button"
                  className="btn btn-soft"
                  onClick={() => setStep(step - 1)}
                >
                  ← Previous Step
                </button>
              )}

              <button
                type="submit"
                className="btn btn-rose"
                disabled={loading}
                style={{ marginLeft: 'auto' }}
              >
                {step === 3 ? (loading ? 'Creating Profile...' : 'Proceed to QR Payment (9857074103) →') : 'Next Step →'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
